import Netcon from '../ReactCustomIcons/netcon.png';
export const NetconLogo: React.FC = () => {
  return (
    <>
      <img src={Netcon} alt="Netcon Logo" />
    </>
  );
};
